import { c as _c } from "react/compiler-runtime";
import { Button } from '@onefootprint/ui';
import type { ElementType } from 'react';
import { useTranslation } from 'react-i18next';
import CardHeading from '../card-heading';
import ArrowCircleIcon from './arrow-circle-icon';
type DemoSentProps = {
  onBook: () => void;
  onDecline: () => void;
  Title?: ElementType;
  Description?: ElementType;
};
const DemoSent = t0 => {
  const $ = _c(36);
  const {
    onBook,
    onDecline,
    Title,
    Description
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "demo"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("authentication", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t(_temp);
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== t2) {
    t3 = <p className="fp-auth-overline mb-6 text-accent">{t2}</p>;
    $[3] = t2;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t(_temp2);
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== t) {
    t5 = t(_temp3);
    $[7] = t;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] !== Description || $[10] !== Title || $[11] !== t4 || $[12] !== t5) {
    t6 = <CardHeading Title={Title} Description={Description} title={t4} description={t5} />;
    $[9] = Description;
    $[10] = Title;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t) {
    t7 = t(_temp4);
    $[14] = t;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  let t8;
  if ($[16] !== t7) {
    t8 = <p className="fp-auth-lead mt-6 text-primary">{t7}</p>;
    $[16] = t7;
    $[17] = t8;
  } else {
    t8 = $[17];
  }
  let t9;
  if ($[18] !== t) {
    t9 = t(_temp5);
    $[18] = t;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] !== onDecline || $[21] !== t9) {
    t10 = <Button className="fp-auth-cta" size="large" variant="secondary" onClick={onDecline}>{t9}</Button>;
    $[20] = onDecline;
    $[21] = t9;
    $[22] = t10;
  } else {
    t10 = $[22];
  }
  let t11;
  if ($[23] !== t) {
    t11 = t(_temp6);
    $[23] = t;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  let t12;
  if ($[25] !== onBook || $[26] !== t11) {
    t12 = <Button className="fp-auth-cta" size="large" suffixIcon={ArrowCircleIcon} onClick={onBook}>{t11}</Button>;
    $[25] = onBook;
    $[26] = t11;
    $[27] = t12;
  } else {
    t12 = $[27];
  }
  let t13;
  if ($[28] !== t10 || $[29] !== t12) {
    t13 = <div className="mt-4 flex flex-wrap gap-3">{t10}{t12}</div>;
    $[28] = t10;
    $[29] = t12;
    $[30] = t13;
  } else {
    t13 = $[30];
  }
  let t14;
  if ($[31] !== t13 || $[32] !== t3 || $[33] !== t6 || $[34] !== t8) {
    t14 = <div className="flex flex-col pr-10">{t3}{t6}{t8}{t13}</div>;
    $[31] = t13;
    $[32] = t3;
    $[33] = t6;
    $[34] = t8;
    $[35] = t14;
  } else {
    t14 = $[35];
  }
  return t14;
};
export default DemoSent;
function _temp($) {
  return $.overline;
}
function _temp2($_0) {
  return $_0.sent.title;
}
function _temp3($_1) {
  return $_1.sent.description;
}
function _temp4($_2) {
  return $_2.sent.prompt;
}
function _temp5($_3) {
  return $_3.sent.decline;
}
function _temp6($_4) {
  return $_4.sent.book;
}